import { Loader2 } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'

import { useSignIn } from '../hooks/use-auth'

/**
 * No navigation on success — `loginRedirect` leaves the page entirely, and
 * `GuestRoute` picks the user back up once Microsoft sends them home.
 */
export function SignInButton() {
  const signIn = useSignIn()
  const [redirecting, setRedirecting] = useState(false)

  return (
    <Button
      type="button"
      className="w-full"
      disabled={redirecting}
      onClick={() => {
        setRedirecting(true)
        signIn()
      }}
    >
      {redirecting ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
      Sign in with Microsoft
    </Button>
  )
}
